import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./CreateHomework.css";
import "./create_hw_file.css";
import axios from "../../../../axios";
// import CreateQuestion from "../Create_Question/CreateQuestionHw";
import CreateQuestion from "./../../../../Components/QuestionEditCreate/CreateQuestion";
import ComponentType from "../../../../Enum/ComponentTypeEnum";

import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Box,
  Alert,
  Tooltip,
} from "@mui/material";
import { IoIosArrowBack } from "react-icons/io";

function CreateHomework() {
  const navigate = useNavigate();
  const { state } = useLocation();
  let teacher_id = JSON.parse(localStorage.getItem("Teacher_id"));
  const standardList = [];
  const sectionList = [];
  const subjectList = [];
  const [click, setClick] = useState(false);
  const [specialChar, setSpecialChar] = useState(false);
  const [specialChar1, setSpecialChar1] = useState(false);
  const [nameOfHW, setName] = useState("");
  const [isFull, setIsFull] = useState(false);
  const [nameofHWDSC, setNameofHWDSC] = useState("");
  const [currentStep, setCurrentStep] = useState(() => {
    // Reload pe last step le lo, default 1 rakho
    const savedStep = localStorage.getItem("currentStepHW");
    return savedStep ? Number(savedStep) : 1;
  });
  const [unsavedChanges, setUnsavedChanges] = useState(false);

  const initialAssessment = {
    name: null,
    description: null,
    teacher_id: teacher_id,
    type_id: "",
    standard_id: {
      id: state?.standardId ?? "",
      name: "",
    },
    section_id: {
      id: state?.sectionId ?? "",
      name: "",
    },
    subject_id: {
      id: state?.subjectId ?? "",
      name: "",
    },
    tags: [],
    status: null,
    total_duration: null,
    schedule_date: null,
    schedule_time: null,
    add_to_live_session: {
      lecture_id: null,
      date: null,
    },
    questions: [],
  };

  const [assessmentDetails, setAssessmentDetails] = useState(initialAssessment);

  const {
    standard_id,
    section_id,
    subject_id,
    name,
    description,
    type_id,
    total_duration,
  } = assessmentDetails || {};

  useEffect(() => {
    const hasFullObject = assessmentDetails.questions.some((obj) => {
      return (
        obj.standard_id &&
        obj.subject_id &&
        obj.section_id &&
        obj.book_id &&
        obj.chapter_id &&
        obj.type_id &&
        obj.question_type !== null &&
        obj.domain_id &&
        obj.skill_id &&
        obj.difficulty_level &&
        obj.title &&
        obj.correct_score !== null &&
        obj.is_mandatory !== null &&
        obj.add_to !== null &&
        obj.attachments.length > 0 &&
        obj.options.length > 0 &&
        obj.correct_answers.length > 0
      );
    });

    setIsFull(hasFullObject);
  }, [assessmentDetails.questions]);

  // const [nameEnable, setNameEnable] = useState(true);
  // const [descriptionEnable, setDescriptionEnable] = useState(true);
  const [dropdownLists, setDropdownLists] = useState({
    standards: null,
    sections: null,
    assessmentTypes: null,
    subjects: null,
  });
  const { standards, sections, assessmentTypes, subjects } = dropdownLists;
  const CTRole_Information = JSON.parse(
    localStorage.getItem("role_as_class_teacher"),
  );
  const CoRole_Information = JSON.parse(
    localStorage.getItem("role_as_co_ordinator"),
  );
  const general_role = JSON.parse(localStorage.getItem("general_role"));
  let school_id = JSON.parse(localStorage.getItem("schoolId"));

  useEffect(() => {
    const getAssessmentType = async () => {
      try {
        let res = await axios.get(
          `/api/v1/homework/homeworkType/get/school/${school_id}`,
        );
        res &&
          setDropdownLists((prev) => ({
            ...prev,
            assessmentTypes: res.data.data,
          }));
      } catch (error) {
        console.log(error);
      }
    };
    getAssessmentType();
    // if (CTRole_Information && CTRole_Information.length > 0) {
    //   CTRole_Information?.forEach((obj) => {
    //     if (obj.is_class_teacher === true) {
    //       if (!standardList.some((i) => i.id === obj.standard_id.id)) {
    //         standardList.push(obj.standard_id);
    //       }
    //       if (!sectionList.some((i) => i.id === obj.section_id.id)) {
    //         sectionList.push(obj.section_id);
    //       }
    //     }
    //   });
    // }
    // if (CoRole_Information && CoRole_Information.length > 0) {
    //   CoRole_Information?.forEach((obj) => {
    //     if (obj?.is_class_co_ordinator === true) {
    //       if (!standardList.some((i) => i.id === obj.standard_id.id)) {
    //         standardList.push(obj.standard_id);
    //       }
    //       if (!sectionList.some((i) => i.id === obj.section_id.id)) {
    //         sectionList.push(obj.section_id);
    //       }
    //     }
    //   });
    // }
    // if (general_role && general_role.length > 0) {
    //   general_role?.forEach((obj) => {
    //     if (!standardList.some((i) => i.id === obj.standard_id.id)) {
    //       standardList.push(obj.standard_id);
    //     }
    //     if (!sectionList.some((i) => i.id === obj.section_id.id)) {
    //       sectionList.push(obj.section_id);
    //     }
    //   });
    // }

    // standardList.length > 0 &&
    //   setDropdownLists((prev) => ({ ...prev, standards: standardList }));

    // sectionList.length > 0 &&
    //   setDropdownLists((prev) => ({ ...prev, sections: sectionList }));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let sectionArr = [];
  let standardArr = [];
  const dropDownHelper = () => {
    function addUniqueObjectToArraystand(obj) {
      if (
        !standardArr.some(
          (item) => JSON.stringify(item) === JSON.stringify(obj),
        )
      ) {
        standardArr.push(obj);
      }
    }
    general_role?.map((obj) => addUniqueObjectToArraystand(obj.standard_id));
    CTRole_Information?.map((obj) =>
      addUniqueObjectToArraystand(obj.standard_id),
    );
    CoRole_Information?.map((obj) =>
      addUniqueObjectToArraystand(obj.standard_id),
    );
  };

  dropDownHelper();

  const handleDropDownSec = () => {
    function addUniqueObjectToArraysect(obj) {
      if (
        !sectionArr.some((item) => JSON.stringify(item) === JSON.stringify(obj))
      ) {
        sectionArr.push(obj);
      }
    }
    general_role?.map((obj) => {
      if (obj?.standard_id?.id === assessmentDetails?.standard_id?.id) {
        addUniqueObjectToArraysect(obj.section_id);
      }
    });
    CTRole_Information?.map((obj) => {
      if (obj?.standard_id?.id === assessmentDetails?.standard_id?.id) {
        addUniqueObjectToArraysect(obj.section_id);
      }
    });
    CoRole_Information?.map((obj) => {
      if (obj?.standard_id?.id === assessmentDetails?.standard_id?.id) {
        addUniqueObjectToArraysect(obj.section_id);
      }
    });
  };
  handleDropDownSec();

  useEffect(() => {
    (async () => {
      let subjects = [];
      if (
        ((CTRole_Information && CTRole_Information.length > 0) ||
          (CoRole_Information && CoRole_Information.length > 0)) &&
        assessmentDetails.standard_id?.id !== "null" &&
        assessmentDetails.section_id?.id !== "null"
      ) {
        subjects = await getSubjects(
          assessmentDetails.standard_id?.id,
          assessmentDetails.section_id?.id,
        ); //obj.subjects_id;
      }
      if (CTRole_Information && CTRole_Information.length > 0) {
        CTRole_Information?.forEach(async (obj) => {
          if (
            obj.standard_id.id === assessmentDetails.standard_id?.id &&
            obj.section_id.id === assessmentDetails.section_id?.id
          ) {
            if (subjects.length > 0) {
              for (const subject of subjects) {
                if (!subjectList.some((i) => i.id === subject.id)) {
                  subjectList.push({ id: subject.id, name: subject.name });
                }
              }
            }
          }
        });
      }
      if (CoRole_Information && CoRole_Information.length > 0) {
        CoRole_Information?.forEach(async (obj) => {
          if (
            obj.standard_id.id === assessmentDetails.standard_id?.id &&
            obj.section_id.id === assessmentDetails.section_id?.id
          ) {
            if (subjects.length > 0) {
              for (const subject of subjects) {
                if (!subjectList.some((i) => i.id === subject.id)) {
                  subjectList.push({ id: subject.id, name: subject.name });
                }
              }
            }
          }
        });
      }

      if (general_role && general_role?.length > 0) {
        general_role?.forEach((obj) => {
          let subjects = obj.subjects_id;
          if (
            obj.standard_id.id === assessmentDetails.standard_id?.id &&
            obj.section_id.id === assessmentDetails.section_id?.id
          ) {
            for (const subject of subjects) {
              if (!subjectList.some((i) => i.id === subject.id)) {
                subjectList.push({ id: subject.id, name: subject.name });
              }
            }
          }
        });
      }
      subjectList.length > 0 &&
        setDropdownLists((prev) => ({ ...prev, subjects: subjectList }));
    })();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assessmentDetails.standard_id, assessmentDetails.section_id]);

  const getSubjects = async (standard_id, section_id) => {
    let arrSubject = [];
    try {
      let res = await axios.get(
        `/api/v1/school/standardId/${standard_id}/sectionId/${section_id}/getSubjects`,
      );

      const data = res?.data?.data;

      // Priority: subjectConfigurations > subjects
      const subjectSource =
        data?.subjectConfigurations?.length > 0
          ? data.subjectConfigurations.map((item) => item.subject)
          : data.subjects;

      subjectSource.forEach((obj) => {
        arrSubject.push(obj);
      });
    } catch (error) {
      console.log(error);
    }
    return arrSubject;
  };

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (unsavedChanges) {
        e.preventDefault();
        e.returnValue = "";
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [unsavedChanges]);

  useEffect(() => {
    if (
      standards &&
      sections &&
      state?.standardId !== undefined &&
      state?.sectionId !== undefined
    ) {
      let standard =
        standards &&
        standards.length &&
        standards.filter((standard) => standard.id == state.standardId);
      let section =
        sections &&
        sections.length &&
        sections.filter((section) => section.id == state.sectionId);
      setAssessmentDetails({
        ...assessmentDetails,
        standard_id: {
          ...assessmentDetails.standard_id,
          name: standard[0].name,
        },
        section_id: {
          ...assessmentDetails.section_id,
          name: section[0].name,
        },
      });
    }
  }, [standards, sections]);

  useEffect(() => {
    if (subjects && subjects.length > 0 && state?.subjectId !== undefined) {
      let subject = subjects.filter((subject) => subject.id == state.subjectId);
      setAssessmentDetails({
        ...assessmentDetails,
        subject_id: {
          ...assessmentDetails.subject_id,
          name: subject[0].name,
        },
      });
    }
  }, [subjects]);

  const steps = [1, 2, 3];

  // STEP-SPECIFIC VALIDATIONS
  const isStep1Invalid = (!nameOfHW && !nameOfHW.trim()) || !description;

  const isEmpty = (val) =>
    val === undefined || val === null || val === "" || val === "null";

  const isStep2Invalid =
    isEmpty(assessmentDetails?.standard_id?.id) ||
    isEmpty(assessmentDetails?.section_id?.id) ||
    isEmpty(assessmentDetails?.subject_id?.id) ||
    isEmpty(assessmentDetails?.type_id);
  // isEmpty(assessmentDetails?.total_duration);

  // CONTROL BUTTON STATE BASED ON CURRENT STEP
  const isNextDisabled =
    (currentStep === 1 && isStep1Invalid) ||
    (currentStep === 2 && isStep2Invalid);

  const isPreviousDisabled = currentStep === 1;

  useEffect(() => {
    if (currentStep === 3) setClick(true);
  }, [currentStep]);

  const savedTempLocalAssesment = JSON.parse(
    localStorage.getItem("temp_Questions_HOMEWORK"),
  );

  console.log("savedTempLocalAssesment", savedTempLocalAssesment);

  useEffect(() => {
    if (!savedTempLocalAssesment) return;

    setAssessmentDetails(savedTempLocalAssesment?.HomeWorkDetails);

    if (savedTempLocalAssesment) {
      setName(savedTempLocalAssesment?.HomeWorkDetails?.name);
      setNameofHWDSC(savedTempLocalAssesment?.HomeWorkDetails?.description);
    }
  }, []);

  const updateAssessmentDetails = (newDetails) => {
    const updated = {
      ...assessmentDetails,
      ...newDetails,
    };

    setAssessmentDetails(updated);

    const savedTemp = JSON.parse(
      localStorage.getItem("temp_Questions_HOMEWORK") || "{}",
    );

    if (!savedTemp) return;

    if (savedTemp?.questions?.length > 0) {
      localStorage.setItem(
        "temp_Questions_HOMEWORK",
        JSON.stringify({
          ...savedTemp,
          HomeWorkDetails: updated,
          questions: savedTemp?.questions || [],
        }),
      );
    }
  };
  const handleBackNavigation = () => {
    if (state?.fromLiveSession === "liveSession") {
      navigate("/liveSession", {
        state: {
          supplement_id: state?.supplement_id,
          addMaterial: state?.redirectStateData?.addMaterial,
          standardId: state?.standardId,
          sectionId: state?.sectionId,
          Subject_id: state?.subjectId ?? state?.Subject_id,
          buttonfunction: state?.redirectStateData?.buttonfunction,
          sectionName: state?.redirectStateData?.sectionName,
          standardsName: state?.redirectStateData?.standardsName,
        },
      });
    } else {
      navigate("/PublishedHomework");
      setUnsavedChanges(true);
    }
  };

  return (
    <>
      <div className="create_wrap w-100 h-100">
        {currentStep !== 3 && (
          <div
            className="mb-4 d-flex align-items-center gap-2"
            onClick={() => {
              handleBackNavigation();
            }}
            style={{ cursor: "pointer" }}
          >
            <IoIosArrowBack
              onClick={() => {
                handleBackNavigation();
              }}
              style={{ cursor: "pointer" }}
            />
            <div className="d-flex flex-column gap-1">
              <span className="head_manual">Homework</span>
              <span
                className="fw-small  text-muted"
                style={{ fontSize: "10px" }}
              >
                Dashboard / Homework / Create Homework
              </span>
            </div>
          </div>
        )}

        {/* Stepper UI */}
        <div className="w-100 py-1" style={{ backgroundColor: "#fff" }}>
          <div className="d-flex align-items-center justify-content-center py-2">
            {steps.map((step, index) => {
              const isCompleted = currentStep > step;
              const isActive = currentStep === step;

              return (
                <React.Fragment key={step}>
                  <div className="d-flex align-items-center">
                    {/* Circle */}
                    <div
                      className="rounded-circle d-flex align-items-center justify-content-center"
                      style={{
                        width: 36,
                        height: 36,
                        backgroundColor:
                          isCompleted || isActive ? "#7e4c32" : "#ccc",
                        color: "#fff",
                        fontWeight: 600,
                        fontSize: 14,
                      }}
                    >
                      {isCompleted ? "✓" : step}
                    </div>

                    {/* Label */}
                    <span
                      className="ms-2 me-3"
                      style={{
                        fontSize: 14,
                        fontWeight: isActive ? 600 : 400,
                        color: isActive ? "#000" : "#999",
                        whiteSpace: "nowrap",
                      }}
                    >
                      Step {step}
                    </span>
                  </div>

                  {/* Line */}
                  {index !== steps.length - 1 && (
                    <div
                      style={{
                        width: 80,
                        height: 2,
                        backgroundColor: isCompleted ? "#7e4c32" : "#ddd",
                        marginRight: 12,
                      }}
                    />
                  )}
                </React.Fragment>
              );
            })}
          </div>
        </div>

        {currentStep === 1 && (
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            mt={4}
            width="100%"
          >
            {/* Homework Name */}
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              mt={4}
              width="100%"
            >
              <Tooltip title={nameOfHW} arrow placement="bottom">
                <TextField
                  variant="outlined"
                  size="small"
                  label="Homework Name"
                  fullWidth
                  sx={{ maxWidth: "80%" }}
                  value={nameOfHW}
                  placeholder="Enter homework name"
                  inputProps={{ maxLength: 100 }}
                  // onChange={(e) => {
                  //   const value = e.target.value;
                  //   const regex = /^([^"/|\\;\-+(){}%!?*&=`']*?)?$/;
                  //   if (regex.test(value) || value === "") {
                  //     setName(value);
                  //     setAssessmentDetails({
                  //       ...assessmentDetails,
                  //       name: value,
                  //     });
                  //     setSpecialChar(false);
                  //   } else if (value !== "") {
                  //     setSpecialChar(true);
                  //   }
                  // }}\

                  // for temproary removng regex check On onChange

                  onChange={(e) => {
                    const value = e.target.value;

                    setName(value);
                    // setAssessmentDetails({
                    //   ...assessmentDetails,
                    //   name: value,
                    // });
                    updateAssessmentDetails({ name: value });

                    // no regex check, so always reset error state
                    setSpecialChar(false);
                  }}
                />
              </Tooltip>
            </Box>
            {specialChar && (
              <Alert severity="error" sx={{ mt: 1, width: "80%" }}>
                *Special Character Not Allowed.
              </Alert>
            )}

            {/* Homework Description */}
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              mt={4}
              width="100%"
            >
              <TextField
                variant="outlined"
                label="Description"
                size="small"
                fullWidth
                multiline
                rows={5}
                sx={{ maxWidth: "80%" }}
                value={nameofHWDSC}
                placeholder="Enter homework description"
                inputProps={{ maxLength: 150 }}
                // onChange={(e) => {
                //   const values = e.target.value;
                //   const regex = /^([^"/|\\;\-+(){}%!?*&=`']*?)?$/;
                //   if (regex.test(values) || values === "") {
                //     setNameofHWDSC(values);
                //     setAssessmentDetails({
                //       ...assessmentDetails,
                //       description: values,
                //     });
                //     setSpecialChar1(false);
                //   } else {
                //     setSpecialChar1(true);
                //   }
                // }}

                // for temproary removng regex check On onChange
                onChange={(e) => {
                  const value = e.target.value;

                  setNameofHWDSC(value);
                  // setAssessmentDetails({
                  //   ...assessmentDetails,
                  //   description: value,
                  // });
                  updateAssessmentDetails({ description: value });

                  // no regex check, so always reset error state
                  setSpecialChar(false);
                }}
              />
            </Box>
            {specialChar1 && (
              <Alert severity="error" sx={{ mt: 1, width: "80%" }}>
                *Special Character Not Allowed.
              </Alert>
            )}
          </Box>
        )}
        {currentStep === 2 && (
          <div className="total_dropdown">
            <div className="selectClassSectionSubject">
              <div className="selectClassSection">
                <FormControl fullWidth size="small" sx={{ minWidth: 150 }}>
                  <InputLabel>Select Class</InputLabel>
                  <Select
                    label="Select Class"
                    disabled={state?.defaultData !== undefined}
                    value={
                      assessmentDetails.standard_id.id === null
                        ? ""
                        : assessmentDetails.standard_id.id
                    }
                    sx={{
                      height: "45px",
                      width: "100%",
                    }}
                    onChange={(e) => {
                      const selectedId = e.target.value;
                      const selected = standardArr.find(
                        (s) => s.id === selectedId,
                      );
                      // setAssessmentDetails({
                      //   ...assessmentDetails,
                      //   standard_id: {
                      //     id: selectedId,
                      //     name: selected?.name || "null",
                      //   },
                      //   subject_id: { id: "null", name: "null" },
                      //   section_id: { id: "null", name: "null" },
                      // });
                      updateAssessmentDetails({
                        standard_id: {
                          id: selectedId,
                          name: selected?.name || "null",
                        },
                        subject_id: { id: "null", name: "null" },
                        section_id: { id: "null", name: "null" },
                      });
                    }}
                  >
                    <MenuItem value="">Select Class</MenuItem>
                    {standardArr?.length > 0 &&
                      [...standardArr]
                        .sort((a, b) => {
                          const aNum = Number(a.name);
                          const bNum = Number(b.name);

                          const bothNumeric = !isNaN(aNum) && !isNaN(bNum);
                          if (bothNumeric) {
                            return aNum - bNum; // numeric sort
                          }

                          return a.name.localeCompare(b.name); // alphabetical sort
                        })
                        .map((standard, index) => (
                          <MenuItem
                            key={index}
                            value={standard?.id}
                            name={standard?.name}
                          >
                            {standard?.name}
                          </MenuItem>
                        ))}
                  </Select>
                </FormControl>
                <FormControl size="small" fullWidth sx={{ minWidth: 150 }}>
                  <InputLabel>Select Section</InputLabel>
                  <Select
                    label="Select Section"
                    disabled={
                      state?.defaultData !== undefined ||
                      !assessmentDetails.standard_id.id
                    }
                    value={
                      assessmentDetails.section_id.id === null
                        ? ""
                        : assessmentDetails.section_id.id
                    }
                    sx={{
                      height: "45px",
                      width: "100%",
                    }}
                    onChange={(e) => {
                      const selectedId = e.target.value;
                      const selected = sectionArr.find(
                        (s) => s.id === selectedId,
                      );
                      // setAssessmentDetails({
                      //   ...assessmentDetails,
                      //   section_id: {
                      //     id: selectedId,
                      //     name: selected?.name || "null",
                      //   },
                      //   subject_id: { id: "null", name: "null" },
                      // });
                      updateAssessmentDetails({
                        section_id: {
                          id: selectedId,
                          name: selected?.name || "null",
                        },
                        subject_id: { id: "null", name: "null" },
                      });
                    }}
                  >
                    <MenuItem value="">Select Section</MenuItem>
                    {assessmentDetails.standard_id.id !== "null" &&
                      sectionArr
                        ?.slice()
                        .sort((a, b) => a.name.localeCompare(b.name))
                        .map((section, index) => (
                          <MenuItem key={index} value={section.id}>
                            {section.name}
                          </MenuItem>
                        ))}
                  </Select>
                </FormControl>
              </div>
              <FormControl size="small" fullWidth sx={{ minWidth: 150 }}>
                <InputLabel>Select Subject</InputLabel>
                <Select
                  label="Select Subject"
                  disabled={
                    state?.defaultData !== undefined ||
                    !assessmentDetails.section_id.id
                  }
                  value={
                    assessmentDetails.subject_id.id === null
                      ? ""
                      : assessmentDetails.subject_id.id
                  }
                  onChange={(e) => {
                    const selectedId = e.target.value;
                    const selected = subjects.find((s) => s.id === selectedId);
                    // setAssessmentDetails({
                    //   ...assessmentDetails,
                    //   subject_id: {
                    //     id: selectedId,
                    //     name: selected?.name,
                    //   },
                    // });
                    updateAssessmentDetails({
                      subject_id: {
                        id: selectedId,
                        name: selected?.name,
                      },
                    });
                  }}
                  sx={{
                    height: "45px",
                    width: "100%",
                  }}
                >
                  <MenuItem value="">Select Subject</MenuItem>
                  {assessmentDetails.standard_id.id !== "null" &&
                    assessmentDetails.section_id.id !== "null" &&
                    subjects?.map((subject, index) => (
                      <MenuItem key={index} value={subject.id}>
                        {subject.name}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </div>
            <div className="selectClassSectionSubject">
              <FormControl fullWidth size="small" sx={{ minWidth: 200 }}>
                <InputLabel>Select Homework Type</InputLabel>
                <Select
                  label="Select Homework Type"
                  value={
                    assessmentDetails.type_id === null
                      ? ""
                      : assessmentDetails.type_id
                  }
                  onChange={(e) =>
                    // setAssessmentDetails({
                    //   ...assessmentDetails,
                    //   type_id: e.target.value,
                    // })
                    updateAssessmentDetails({
                      type_id: e.target.value,
                    })
                  }
                  sx={{
                    height: "45px",
                    width: "100%",
                  }}
                >
                  <MenuItem value="">Select Homework Type</MenuItem>
                  {assessmentTypes?.map((type, index) => (
                    <MenuItem key={index} value={type.id}>
                      {type.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              {/* Duration */}
              <TextField
                type="number"
                label="Duration (in minutes) (Optional)"
                fullWidth
                size="small"
                value={assessmentDetails.total_duration}
                onChange={(e) => {
                  let enteredValue = e.target.value;
                  if (
                    /^\d*$/.test(enteredValue) ||
                    parseInt(enteredValue, 10) === ""
                  ) {
                    if (isNaN(enteredValue) || enteredValue < 0) {
                      enteredValue = 0;
                    } else if (enteredValue > 1440) {
                      enteredValue = 1440;
                    }
                    // setAssessmentDetails({
                    //   ...assessmentDetails,
                    //   total_duration: enteredValue || 0,
                    // });
                    updateAssessmentDetails({
                      total_duration: enteredValue,
                    });
                  }
                }}
                inputProps={{ max: 1440 }}
                sx={{ minWidth: 200, height: "45px" }}
              />
            </div>
          </div>
        )}

        {currentStep === 3 && (
          <CreateQuestion
            componentType={ComponentType.HOMEWORK}
            setClickFromCreate={setCurrentStep}
            assessmentDetails={assessmentDetails}
            setAssessmentDetails={setAssessmentDetails}
            redirectStateData={state?.redirectStateData ?? null}
            setUnsavedChanges={setUnsavedChanges}
          />
        )}
        {currentStep !== 3 && (
          <div className="d-flex align-items-center justify-content-end p-4 w-100 gap-4">
            <button
              className={
                isPreviousDisabled ? "Next_buttonDisable" : "button_css"
              }
              disabled={isPreviousDisabled}
              onClick={() => setCurrentStep(currentStep - 1)}
            >
              Previous
            </button>
            <button
              disabled={isNextDisabled}
              className={isNextDisabled ? "Next_buttonDisable" : "button_css"}
              style={{ marginRight: "6rem" }}
              onClick={() => setCurrentStep(currentStep + 1)}
            >
              Next
            </button>
          </div>
        )}
      </div>
    </>
  );
}

export default CreateHomework;
